// Shared between Accounts.tsx and InvoiceDetailModal.tsx (which Accounts and ChargesTab both
// render) -- kept in lib/ rather than duplicated in each, or owned by one page, since a shared
// component shouldn't import formatting helpers from a specific page.

// DRAFT/ISSUED/VOID/CREDITED -- the real live `invoices.status` values (added in Charges Phase 1). No
// payment-tracking status (SENT/PAID/OVERDUE) exists on this table.
export const STATUS_COLORS: Record<string, string> = {
  DRAFT:  'bg-gray-100 text-gray-700',
  ISSUED: 'bg-blue-100 text-blue-700',
  VOID:   'bg-red-50 text-red-400',
  CREDITED: 'bg-amber-100 text-amber-800',
}

export function fmt(n: number, currency = 'GBP') {
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format(n)
}

export function fmtDate(d?: string | null) {
  if (!d) return '—'
  return new Date(d).toLocaleDateString('en-GB')
}
